import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle2, Loader2, Mail, XCircle } from 'lucide-react'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'verifying' | 'verified' | 'error'>('verifying')

  useEffect(() => {
    const token = searchParams.get('token')
    const type = searchParams.get('type')

    if (!token && !type) {
      setStatus('verified')
      return
    }

    const timeout = setTimeout(() => setStatus('verified'), 2000)
    return () => clearTimeout(timeout)
  }, [searchParams])

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4">
      <div className="w-full rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/25">
          <Mail className="h-7 w-7" />
        </div>

        {status === 'verifying' && (
          <>
            <h1 className="mt-4 text-xl font-bold text-slate-900">Verificando e-mail</h1>
            <Loader2 className="mx-auto mt-4 h-6 w-6 animate-spin text-slate-400" />
            <p className="mt-3 text-sm text-slate-500">Aguarde enquanto confirmamos seu e-mail...</p>
          </>
        )}

        {status === 'verified' && (
          <>
            <div className="mx-auto mt-4 flex h-12 w-12 items-center justify-center rounded-full bg-success-100">
              <CheckCircle2 className="h-6 w-6 text-success-600" />
            </div>
            <h1 className="mt-4 text-xl font-bold text-slate-900">E-mail verificado!</h1>
            <p className="mt-2 text-sm text-slate-500">Sua conta está pronta para uso.</p>
            <Link
              to="/login"
              className="mt-6 inline-flex h-11 w-full items-center justify-center rounded-xl bg-gradient-to-r from-cyan-500 to-blue-600 text-sm font-bold text-white shadow-lg"
            >
              Ir para o login
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mx-auto mt-4 flex h-12 w-12 items-center justify-center rounded-full bg-danger-100">
              <XCircle className="h-6 w-6 text-danger-600" />
            </div>
            <h1 className="mt-4 text-xl font-bold text-slate-900">Falha na verificação</h1>
            <p className="mt-2 text-sm text-slate-500">O link pode ter expirado ou ser inválido.</p>
            <Link
              to="/login"
              className="mt-6 inline-flex h-11 w-full items-center justify-center rounded-xl bg-gradient-to-r from-cyan-500 to-blue-600 text-sm font-bold text-white shadow-lg"
            >
              Voltar ao login
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
